import { PropType } from "vue";
import { DateTimeProps } from "./type";

export default {
  modelValue: [String] as PropType<DateTimeProps["modelValue"]>,
};
